export default __webpack_public_path__ + "static/media/Layer_1.0e21cf95.svg";